import { render, staticRenderFns } from "./AdminFooter.vue?vue&type=template&id=0c638c9e&"
var script = {}
import style0 from "./AdminFooter.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports